export default {
    computed: {
        isIOS() {
            return this.$store.state.isIOS
        },
        loading: {
            get() {
                return this.$store.state.loading
            },
            set(_f) {
                this.$store.commit('setLoading', _f)
            }
        },
        isLoading() {
            return this.loading > 0
        },
        menuOpen: {
            get() {
                return this.$store.state.stageWw > 1000
                    ? true
                    : this.$store.state.menuOpen
            },
            set(_f) {
                this.$store.commit('setMenuOpen', _f)
            }
        },
        userData() {
            return this.$store.state.loginData
        },
        isLogin() {
            return this.userData === null ? false : true
        },
        myLessons() {
            return this.$store.state.myLessons
        },
        noteList() {
            return this.$store.state.noteList
        },
        lessonExam() {
            return this.$store.state.lessonExam
        },
        wordSound() {
            return this.$store.state.wordSound
        },
        //全部學習紀錄(單字及測驗)
        studyRecord() {
            return this.$store.state.studyRecord
        },
        //學習紀錄byDate(月曆使用)
        recordData() {
            return this.$store.state.recordData
        },
        word: {
            get() {
                return this.$store.state.word
            },
            set(val) {
                this.$store.commit('word', val)
            }
        },
        classList() {
            return this.$store.state.classList
        },
        selectDate() {
            return this.$store.state.selectDate
        },
        examEndMata: {
            get() {
                return this.$store.state.examEndMata
            },
            set(val) {
                this.$store.commit('examEndMata', val)
            }
        },
        //測驗時間 null 代表無限制
        examDuration() {
            return this.$store.getters['examDuration']
        },
        AddExamRecordMessage() {
            return this.$store.state.AddExamRecordMessage
        }
    },
    methods: {
        soundLibInit(pathList) {
            this.$store.commit('soundLibInit', pathList)
        },
        loginApi(userInfo) {
            this.$store.dispatch('loginApi', userInfo)
        },
        logoutApi() {
            this.$store.dispatch('logoutApi')
        },
        getTodayVocabulary() {
            this.$store.dispatch('getTodayVocabulary')
        },
        todayListNext() {
            this.$store.commit('todayListNext')
        },
        todayListBack() {
            this.$store.commit('todayListBack')
        },
        //取回測驗
        getLessonExam(date) {
            this.$store.dispatch('getLessonExam', date)
        },
        getLessonExamById(LessonId) {
            this.$store.dispatch('getLessonExamById', LessonId)
        },
        clearLessonExam() {
            this.$store.commit('setLessonExam', null)
        },
        saveExamRecord() {
            this.$store.dispatch('saveExamRecord')
        },
        //取得全部學習紀錄(單字及測驗) API
        getMyStudyRecord(date) {
            this.$store.dispatch('getMyStudyRecord', date)
        },
        //取得學習紀錄byDate(月曆使用)
        getRecordByDate(startDate, endDate) {
            this.$store.dispatch('getRecordByDate', {
                startDate,
                endDate
            })
        },
        //新增單字學習紀錄
        addVocabularyRecord({ VocabularyId, Time, LessonId }) {
            this.$store.dispatch('addVocabularyRecord', {
                VocabularyId,
                Time,
                LessonId
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/delegate/mainDelegate.js